import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";

const TYPE_OPTIONS = [
  { value: "text", label: "Short text" },
  { value: "textarea", label: "Long text" },
  { value: "select", label: "Choose one" },
  { value: "multiselect", label: "Choose several (tick boxes)" },
  { value: "checkbox", label: "Yes / No" },
];

function newQuestion() {
  return { id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`, label: "", type: "textarea", options: [], required: true };
}

export default function QuestionnaireBuilder({ questions, onChange }) {
  const list = questions || [];
  const [optionsDraft, setOptionsDraft] = useState({});

  const update = (i, patch) => onChange(list.map((q, idx) => (idx === i ? { ...q, ...patch } : q)));
  const remove = (i) => onChange(list.filter((_, idx) => idx !== i));
  const add = () => onChange([...list, newQuestion()]);

  const commitOptions = (q, i) => {
    const raw = optionsDraft[q.id];
    if (raw === undefined) return;
    update(i, { options: raw.split(",").map((s) => s.trim()).filter(Boolean) });
  };

  return (
    <div className="space-y-3" data-testid="admin-shop-questionnaire-builder">
      {list.map((q, i) => (
        <div key={q.id} className="rounded-xl border border-slate-200 p-4 space-y-3" data-testid={`admin-shop-question-row-${i}`}>
          <div className="flex gap-2">
            <input
              value={q.label}
              onChange={(e) => update(i, { label: e.target.value })}
              placeholder="Question for the customer"
              data-testid={`admin-shop-question-label-${i}`}
              className="flex-1 rounded-xl border border-slate-200 px-3 py-2 text-sm"
            />
            <button type="button" onClick={() => remove(i)} data-testid={`admin-shop-question-remove-${i}`}
              className="shrink-0 rounded-xl border border-slate-200 px-3 text-red-600 hover:bg-red-50">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <select value={q.type} onChange={(e) => update(i, { type: e.target.value })}
              data-testid={`admin-shop-question-type-${i}`} className="rounded-xl border border-slate-200 px-3 py-2 text-sm">
              {TYPE_OPTIONS.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
            <label className="flex items-center gap-1.5 text-sm text-ink-muted">
              <input type="checkbox" checked={!!q.required} onChange={(e) => update(i, { required: e.target.checked })}
                data-testid={`admin-shop-question-required-${i}`} />
              Required
            </label>
          </div>
          {(q.type === "select" || q.type === "multiselect") && (
            <input
              value={optionsDraft[q.id] !== undefined ? optionsDraft[q.id] : (q.options || []).join(", ")}
              onChange={(e) => setOptionsDraft((d) => ({ ...d, [q.id]: e.target.value }))}
              onBlur={() => commitOptions(q, i)}
              placeholder="Options, separated by commas"
              data-testid={`admin-shop-question-options-${i}`}
              className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm"
            />
          )}
        </div>
      ))}
      <button type="button" onClick={add} data-testid="admin-shop-add-question"
        className="btn-outline text-sm">
        <Plus className="w-4 h-4" /> Add question
      </button>
    </div>
  );
}
